export default __webpack_public_path__ + "static/media/house.8e342f3a.svg";